const VrrpIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="76px"
            height="51px"
            viewBox="-0.5 -0.5 76 51"
        >
            <defs />
            <g>
                <image
                    x="-0.5"
                    y="-0.5"
                    width="74.54"
                    height="50"
                    xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MS42MyA1NC44OSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyYTRlNjk7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSLQodC70L7QuV8yIiBkYXRhLW5hbWU9ItCh0LvQvtC5IDIiPjxnIGlkPSJfMi4yIiBkYXRhLW5hbWU9IjIuMiI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNzAuMjksNTQuODlIMTNDLTQuMzYsNTIuNi0zLjg5LDI1LDExLjc0LDIyLjhjMS4xOC0xMC42OSwxMS43LTExLDE0LjI4LTlDMjgsMTAuNDIsMzQuODctMi42Nyw1MS4yLjQ5UzcxLjQ3LDE4LjgyLDcxLjUyLDI2LjE1QTE0Ljc0LDE0Ljc0LDAsMCwxLDgxLjYyLDQxLDE0LDE0LDAsMCwxLDcwLjI5LDU0Ljg5WiIvPjwvZz48L2c+PC9zdmc+"
                    preserveAspectRatio="none"
                />
            </g>
        </svg>
    );
};

export default VrrpIcon;
